import React from 'react';
import styled from 'styled-components';
import { theme, toRem } from '../../design';
import { Icon } from '../Icon';
import { Logo } from './index';

const Container = styled.div`
  margin-bottom: ${toRem(theme.spacing.small)};
`;

const LineContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 ${toRem(12)};
`;

const Line = styled.div`
  width: ${toRem(65)};
  border-bottom: dashed;
  border-width: ${toRem(1)};
  border-color: ${theme.color.neutral[400]};
`;

const Square = styled.div`
  width: ${toRem(4)};
  height: ${toRem(4)};
  background-color: ${theme.color.neutral[400]};
  rotate: 45deg;
`;

export const SquareConnectLogo = () => (
  <Container>
    <Logo />
    <LineContainer>
      <Square />
      <Line />
      <Square />
    </LineContainer>
    <Icon width={36} height={36} icon="SquareLogo" />
  </Container>
);
